import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { BenefitsSection } from './components/BenefitsSection';
import { CountdownTimer } from './components/CountdownTimer';
import { TechniquesSection } from './components/TechniquesSection';
import { BonusesSection } from './components/BonusesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { InstructorSection } from './components/InstructorSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  // Implement smooth scroll for anchor links
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a');
      if (anchor && anchor.hash && anchor.hash.startsWith('#') && anchor.origin === window.location.origin) {
        e.preventDefault();
        const element = document.querySelector(anchor.hash);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  return <div className="min-h-screen bg-[#0D0118] text-white font-sans selection:bg-[#FF2D8A] selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <BenefitsSection data-id="element-2" />
      <CountdownTimer data-id="element-3" />
      <TechniquesSection data-id="element-4" />
      <BonusesSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <InstructorSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}